export default __webpack_public_path__ + "static/media/situation-coref-switch-mode.5153968c.gif";